import { render, staticRenderFns } from "./templalteIntro.vue?vue&type=template&id=587b999a&scoped=true"
import script from "./templalteIntro.vue?vue&type=script&lang=js"
export * from "./templalteIntro.vue?vue&type=script&lang=js"
import style0 from "./templalteIntro.vue?vue&type=style&index=0&id=587b999a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b999a",
  null
  
)

export default component.exports